<div class="container-fluid">
    <div class="row">
      <div class="col-12" style="display:flex;justify-content: flex-start;">
        <button *ngIf="caseDetails && caseDetails.settings.allowEditDepositOrder" class="btn btn-primary m-3" (click)="openCreateModal()">
            <i class="fa fa-plus-circle"></i>
            <span> {{'AddDepositOrder' | translate}} </span>
        </button>
      </div>
      <div class="col-sm-12">
        <div *ngIf="!showAddPage && !showEditPage" class="card">
          <table class="table table-striped mt-3">
            <thead class="thead-dark">
              <tr>
                <th>{{ "DepositOrderNumber" | translate }}</th>
                <th>{{ "DepositPeriod" | translate }}</th>
                <th>{{ "DepositDate" | translate }}</th>
                <th>{{ "DepositBranch" | translate }}</th>
                <th>{{ "Notes" | translate }}</th>
                <th>{{ "DipositorName" | translate }}</th>
                <th>{{ "DipositorIdentiy" | translate }}</th>
                <th>{{ "createDate" | translate }}</th>
                <th>{{"Preview" | translate}}</th>
                <th *ngIf="caseDetails && caseDetails.settings.allowEditDepositOrder" scope="col">{{ "Edit" | translate }}</th>
                <th *ngIf="caseDetails && caseDetails.settings.allowEditDepositOrder" scope="col">{{ "Delete" | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let depositOrder of depositOrdersArr">
                <td>{{ depositOrder.depositOrderNumber }}</td>
                <td>{{ depositOrder.period }}</td>
                <td>{{ depositOrder.depositDate | toDateOnly }}</td>
                <td>{{ depositOrder.depositAreaName }}</td>
                <td>{{ depositOrder.notes }}</td>
                <td>{{ depositOrder.dipositorName }}</td>
                <td>{{ depositOrder.dipositorNId }}</td>
                <td>{{ depositOrder.createdOn | toDateOnly }}
                  <br />
                       
                  <span *ngIf="depositOrder.creatorName!=null" style="font-size: 10px; ">{{'companyandBy'|translate}}:{{
                    depositOrder.creatorName}}</span>
                  
                </td>
                <td>
                  <a (click)="depositOrderPreview(depositOrder,depositOrderPreviewModal)">
                      <i class="fa fa-eye"></i>
                  </a>
                </td>
                <td *ngIf="caseDetails && caseDetails.settings.allowEditDepositOrder">
                  <a style="cursor: pointer;" (click)="editDepositOrder(depositOrder)" >
                    <i class="fa fa-edit"></i>
                  </a>
                </td>
                <td *ngIf="caseDetails && caseDetails.settings.allowEditDepositOrder">
                  <a (click)="deleteDepositOrder(depositOrder.depositOrderId, deleteModal)" style="cursor: pointer;">
                    <i class="fa fa-trash"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- add page -->
        <div *ngIf="showAddPage" class="card p-3">
          <h4 class="modal-title" id="modal-basic-title">
            {{ "AddDepositOrder" | translate }}
          </h4>
          <div class="form-group row mt-3">
            <div class="col-lg-6">
              <div class="divformlabel">
                <label>{{ "DepositOrderNumber" | translate }}</label>
                <span
                  *ngIf="DepositOrderNumber.invalid"
                  class="alert error-span"
                 
                >
                  <div *ngIf="DepositOrderNumber.errors?.required">*</div>
                </span>
              </div>
              <input
                id="DepositOrderNumber"
                required
                #DepositOrderNumber="ngModel"
                type="text"
                (keyup)="numberOnly($event, false)"
                class="form-control"
                [(ngModel)]="depositOrderNumber"
                [ngModelOptions]="{ standalone: true }"
                placeholder="{{ 'DepositOrderNumber' | translate }}"
              />
            </div>
            <div class="col-lg-6">
              <div class="divformlabel">
                <label>
                  {{ "DepositPeriod" | translate }}
                </label>
                <span
                  *ngIf="DepositPeriod.invalid"
                  class="alert error-span"
                 
                >
                  <div *ngIf="DepositPeriod.errors?.required">*</div>
                </span>
              </div>
              <input
                (keyup)="numberOnly($event, false)"
                required
                #DepositPeriod="ngModel"
                name="DepositPeriod"
                id="DepositPeriod"
                [(ngModel)]="period"
                type="text"
                class="form-control"
                placeholder="{{ 'DepositPeriod' | translate }}"
              />
            </div>
          </div>
          <div class="form-group row mt-3">
            <div class="col-lg-6">
              <div style="display: flex; flex-wrap: nowrap; height: 30px">
                <label> {{ "DepositDate" | translate }}</label>
                <span
                  *ngIf="!depositDate"
                  class="alert error-span"
                 
                >
                  *
                </span>
              </div>
              <datepicker
                [(selectedDate)]="currentDate"
                (selectedDateChange)="SelectedDateChange($event)"
                [selectedDateType]="2"
              ></datepicker>
            </div> 
            <div class="col-lg-6">
              <div class="divformlabel">
                <label>{{ "DepositBranch" | translate }}</label>
                <span
                  *ngIf="DepositBranch.invalid"
                  class="alert error-span"
                 
                >
                  <div *ngIf="DepositBranch.errors?.required">*</div>
                </span>
              </div>
              <ng-select
                id="DepositBranch"
                required
                #DepositBranch="ngModel"
                class="form-control-select"
                [items]="branchesArr"
                bindLabel="text"
                bindValue="id"
                [(ngModel)]="depositAreaId"
                [ngModelOptions]="{ standalone: true }"
                placeholder="{{ 'DepositBranch' | translate }}"
              >
              </ng-select>
            </div>
          </div>
          <div class="form-group row mt-3">
            <div class="col-lg-6">
              <div style="display: flex; flex-wrap: nowrap; height: 30px">
                <label>{{ "DipositReason" | translate }}</label>
                <span
                  *ngIf="DipositReason.invalid"
                  class="alert error-span"
                 
                >
                  <div *ngIf="DipositReason.errors?.required">*</div>
                </span>
              </div>
              <textarea
                id="DipositReason"
                required
                #DipositReason="ngModel"
                class="form-control"
                rows="2"
                [(ngModel)]="reason"
                [ngModelOptions]="{ standalone: true }"
                placeholder="{{ 'DipositReason' | translate }}"
              >
              </textarea>
            </div>
            <div class="col-lg-6">
              <div style="display: flex; flex-wrap: nowrap; height: 30px">
                <label>{{ "Notes" | translate }}</label>
                <span
                  *ngIf="Notes.invalid"
                  class="alert error-span"
                 
                >
                  <div *ngIf="Notes.errors?.required">*</div>
                </span>
              </div>
              <textarea
                id="Notes"
                required
                #Notes="ngModel"
                class="form-control"
                rows="2"
                [(ngModel)]="notes"
                [ngModelOptions]="{ standalone: true }"
                placeholder="{{ 'Notes' | translate }}"
              >
              </textarea>
            </div>
          </div>
          <div class="form-group row mt-3">
            <div class="col-lg-4">
              <div class="divformlabel">
                <label>{{ "DipositorName" | translate }}</label>
                <span
                  *ngIf="DipositorName.invalid"
                  class="alert error-span"
                 
                >
                  <div *ngIf="DipositorName.errors?.required">*</div>
                </span>
              </div>
              <input
                id="DipositorName"
                required
                #DipositorName="ngModel"
                class="form-control"
                [(ngModel)]="dipositorName"
                [ngModelOptions]="{ standalone: true }"
                placeholder="{{ 'DipositorName' | translate }}"
              />
            </div>
            <div class="col-lg-4">
              <div class="divformlabel">
                <label>{{ "DipositorIdentiyType" | translate }}</label>
                <span
                  *ngIf="identityTypes.invalid"
                  class="alert error-span"
                 
                >
                  <div *ngIf="identityTypes.errors?.required">*</div>
                </span>
              </div>
              <ng-select
                id="identityTypes"
                required
                #identityTypes="ngModel"
                class="form-control-select"
                [items]="identityTypesArr"
                (change)="changeIdentityType()"
                bindLabel="text"
                bindValue="id"
                [(ngModel)]="dipositorIentiyTypeId"
                [ngModelOptions]="{ standalone: true }"
                placeholder="{{ 'DipositorIdentiyType' | translate }}"
              >
              </ng-select>
            </div>
            <div class="col-lg-4">
              <div class="divformlabel">
                <label>
                  {{ "DipositorIdentiy" | translate }}
                </label>
                <span
                  *ngIf="IdentityNumber.invalid"
                  class="alert error-span"
                 
                >
                  <div *ngIf="IdentityNumber.errors?.required">*</div>
                </span>
              </div>
              <input
                (keyup)="numberOnly($event, true)"
                required
                #IdentityNumber="ngModel"
                minlength="10"
                maxlength="10"
                name="IdentityNumber"
                id="IdentityNumber"
                [(ngModel)]="dipositorNId"
                type="text"
                class="form-control"
                placeholder="{{ 'DipositorIdentiy' | translate }}"
              />
              <span
                class="alert"
                style="
                  color: red;
                  white-space: nowrap;
                  line-height: 0;
                  padding: 0;
                  margin-top: 8px;
                  position: absolute;
                "
              >
                <div
                  *ngIf="
                    IdentityNumber.errors?.minlength &&
                    isValidIqamaNumber &&
                    isValidIdentityNumber
                  "
                >
                  {{ "IdentityNumberMustBe10Number" | translate }}
                </div>
                <div *ngIf="(!isValidIqamaNumber && !IdentityNumber.errors?.required) || (!isValidIdentityNumber && !IdentityNumber.errors?.required) "
                >
                  {{ "IdentityNumberIsNotValid" | translate }}
                </div>
                
              </span>
            </div>
          </div>
          <div class="form-group row mt-3">
            <div class="col-lg-6">
              <div class="divformlabel">
                <label>{{ "EmployeeName" | translate }}</label>
                <span
                  *ngIf="EmployeeName.invalid"
                  class="alert error-span"
                 
                >
                  <div *ngIf="EmployeeName.errors?.required">*</div>
                </span>
              </div>
              <input
                id="EmployeeName"
                required
                #EmployeeName="ngModel"
                class="form-control"
                [(ngModel)]="employeeName"
                [ngModelOptions]="{ standalone: true }"
                placeholder="{{ 'EmployeeName' | translate }}"
              />
            </div>
            <div class="col-lg-6">
              <div class="divformlabel">
                <label>
                  {{ "EmployeeNId" | translate }}
                </label>
                <span
                  *ngIf="EmployeeNId.invalid"
                  class="alert error-span"
                 
                >
                  <div *ngIf="EmployeeNId.errors?.required">*</div>
                </span>
              </div>
              <input
                (keyup)="numberOnly($event, true)"
                required
                #EmployeeNId="ngModel"
                minlength="10"
                maxlength="10"
                name="EmployeeNId"
                id="EmployeeNId"
                [(ngModel)]="employeeNId"
                type="text"
                class="form-control"
                placeholder="{{ 'EmployeeNId' | translate }}"
              />
              <span class="alert" style="color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px;position: absolute;">
                <div
                  *ngIf="!employeeNIdIsValid || EmployeeNId.errors?.minlength">
                  {{ "IdentityNumberIsNotValid" | translate }}
                </div>
              </span>
            </div>
          </div>
          <div class="form-group row mt-3">
            <div class="col-lg-6">
              <div class="divformlabel">
                <label>{{ "OfficerNameDiposit" | translate }}</label>
                <span
                  *ngIf="OfficerNameDiposit.invalid"
                  class="alert error-span"
                 
                >
                  <div *ngIf="OfficerNameDiposit.errors?.required">*</div>
                </span>
              </div>
              <input
                id="OfficerNameDiposit"
                required
                #OfficerNameDiposit="ngModel"
                class="form-control"
                [(ngModel)]="officerName"
                [ngModelOptions]="{ standalone: true }"
                placeholder="{{ 'OfficerNameDiposit' | translate }}"
              />
            </div>
            <div class="col-lg-6">
              <div class="divformlabel">
                <label>
                  {{ "OfficerNId" | translate }}
                </label>
                <span
                  *ngIf="OfficerNId.invalid"
                  class="alert error-span"
                 
                >
                  <div *ngIf="OfficerNId.errors?.required">*</div>
                </span>
              </div>
              <input
                (keyup)="numberOnly($event, true)"
                required
                #OfficerNId="ngModel"
                minlength="10"
                maxlength="10"
                name="OfficerNIdd"
                id="OfficerNIdd"
                [(ngModel)]="officerNId"
                type="text"
                class="form-control"
                placeholder="{{ 'OfficerNId' | translate }}"
              />
              <span class="alert" style="color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px;position: absolute;">
                <div
                  *ngIf="OfficerNId.errors?.minlength || !officerNIdIsValid">
                  {{ "IdentityNumberIsNotValid" | translate }}
                </div>
              </span>
            </div>
          </div>
          <div class="form-group row mt-3">
            <div class="col-lg-6 row">
              <div style="display: flex; flex-wrap: nowrap; height: 30px">
                <label>{{ "IsVisitAllowed" | translate }}</label>
              </div>
              <div class="col-lg-6">
                <div
                  class="custom-control custom-checkbox"
                  style="display: flex; align-items: center"
                >
                  <input
                    [checked]="isVisitAllowed == true"
                    (change)="isVisitAllowed = true"
                    type="radio"
                    name="isVisitedAllowed"
                  />
                  <label style="margin-top: 4px">
                    <span>{{ "Yes" | translate }}</span>
                  </label>
                </div>
              </div>
              <div class="col-lg-6">
                <div
                  class="custom-control custom-checkbox"
                  style="display: flex; align-items: center"
                >
                  <input
                    [checked]="isVisitAllowed == false"
                    (change)="isVisitAllowed = false"
                    type="radio"
                    name="isVisitedAllowed"
                  />
                  <label style="margin-top: 4px">
                    <span>{{ "No" | translate }}</span>
                  </label>
                </div>
              </div>
            </div> 
            <div class="col-lg-6 row">
              <div style="display: flex; flex-wrap: nowrap; height: 30px">
                <label>{{ "DepositType" | translate }}</label>
              </div>
              <div class="col-lg-6">
                <div
                  class="custom-control custom-checkbox"
                  style="display: flex; align-items: center"
                >
                  <input
                    [checked]="isNormal == true"
                    (change)="isNormal = true"
                    type="radio"
                    name="isNormal"
                  />
                  <label style="margin-top: 4px">
                    <span>{{ "Normal" | translate }}</span>
                  </label>
                </div>
              </div>
              <div class="col-lg-6">
                <div
                  class="custom-control custom-checkbox"
                  style="display: flex; align-items: center"
                >
                  <input
                    [checked]="isNormal == false"
                    (change)="isNormal = false"
                    type="radio"
                    name="isNormal"
                  />
                  <label style="margin-top: 4px">
                    <span>{{ "UnNormal" | translate }}</span>
                  </label>
                </div>
              </div>
            </div> 
          </div>
          <div class="row mt-3" style="justify-content: center;">
            <button [disabled]="!officerNIdIsValid || !employeeNIdIsValid ||DepositOrderNumber.invalid || DepositPeriod.invalid || !depositDate || DepositBranch.invalid || DipositReason.invalid || Notes.invalid || DipositorName.invalid || identityTypes.invalid || !isValidIdentityNumber || !isValidIqamaNumber || IdentityNumber.invalid || EmployeeName.invalid || EmployeeNId.invalid || OfficerNameDiposit.invalid || OfficerNId.invalid" 
              (click)="AddDepositOrder()"
              style="color: black; font-weight: bold"
              type="button"
              class="btn btn-primary col-lg-3 m-1"
              data-bs-dismiss="modal"
            >
              {{ "Save and Back" | translate }}
            </button>
            <button
              type="button"
              class="btn btn-danger col-lg-3 m-1"
              (click)="showAddPage=false; showEditPage=false;"
            >
              {{ "BackLists" | translate }}
            </button>
          </div>
          
        </div>
        <!-- edit page -->
        <div *ngIf="showEditPage" class="card p-3">
          <h4 class="modal-title" id="modal-basic-title">
            {{ "Edit Deposit Order" | translate }}
          </h4>
          <div class="form-group row mt-3">
            <div class="col-lg-6">
              <div class="divformlabel">
                <label>{{ "DepositOrderNumber" | translate }}</label>
                <span
                  *ngIf="EditDepositOrderNumber.invalid"
                  class="alert"
                  style="
                    color: red;
                    white-space: nowrap;
                    line-height: 0;
                    padding: 0;
                    margin-top: 8px;
                  "
                >
                  <div *ngIf="EditDepositOrderNumber.errors?.required">*</div>
                </span>
              </div>
              <input
                id="EditDepositOrderNumber"
                required
                #EditDepositOrderNumber="ngModel"
                type="text"
                (keyup)="numberOnly($event, false)"
                class="form-control"
                [(ngModel)]="editedDepositOrder.depositOrderNumber"
                [ngModelOptions]="{ standalone: true }"
                placeholder="{{ 'DepositOrderNumber' | translate }}"
              />
            </div>
            <div class="col-lg-6">
              <div class="divformlabel">
                <label>
                  {{ "DepositPeriod" | translate }}
                </label>
                <span
                  *ngIf="EditDepositPeriod.invalid"
                  class="alert"
                  style="
                    color: red;
                    white-space: nowrap;
                    line-height: 0;
                    padding: 0;
                    margin-top: 8px;
                  "
                >
                  <div *ngIf="EditDepositPeriod.errors?.required">*</div>
                </span>
              </div>
              <input
                (keyup)="numberOnly($event, false)"
                required
                #EditDepositPeriod="ngModel"
                name="EditDepositPeriod"
                id="EditDepositPeriod"
                [(ngModel)]="editedDepositOrder.period"
                type="text"
                class="form-control"
                placeholder="{{ 'DepositPeriod' | translate }}"
              />
            </div>
          </div>
          <div class="form-group row mt-3">
            <div class="col-lg-6">
              <div style="display: flex; flex-wrap: nowrap; height: 30px">
                <label> {{ "DepositDate" | translate }}</label>
                <span
                  *ngIf="!editedDepositOrder.depositDate"
                  class="alert"
                  style="
                    color: red;
                    white-space: nowrap;
                    line-height: 0;
                    padding: 0;
                    margin-top: 8px;
                  "
                >
                  *
                </span>
              </div>
              <datepicker
                (selectedDateChange)="SelectedDateChangeEdit($event)"
                [selectedDateType]="2"
                [(selectedDate)]="editedDate"
              ></datepicker>
            </div> 
            <div class="col-lg-6">
              <div class="divformlabel">
                <label>{{ "DepositBranch" | translate }}</label>
                <span
                  *ngIf="EditDepositBranch.invalid"
                  class="alert"
                  style="
                    color: red;
                    white-space: nowrap;
                    line-height: 0;
                    padding: 0;
                    margin-top: 8px;
                  "
                >
                  <div *ngIf="EditDepositBranch.errors?.required">*</div>
                </span>
              </div>
              <ng-select
                id="EditDepositBranch"
                required
                #EditDepositBranch="ngModel"
                class="form-control-select"
                [items]="branchesArr"
                bindLabel="text"
                bindValue="id"
                [(ngModel)]="editedDepositOrder.depositAreaId"
                [ngModelOptions]="{ standalone: true }"
                placeholder="{{ 'DepositBranch' | translate }}"
              >
              </ng-select>
            </div>
          </div>
          <div class="form-group row mt-3">
            <div class="col-lg-6">
              <div style="display: flex; flex-wrap: nowrap; height: 30px">
                <label>{{ "DipositReason" | translate }}</label>
                <span
                  *ngIf="EditDipositReason.invalid"
                  class="alert"
                  style="
                    color: red;
                    white-space: nowrap;
                    line-height: 0;
                    padding: 0;
                    margin-top: 8px;
                  "
                >
                  <div *ngIf="EditDipositReason.errors?.required">*</div>
                </span>
              </div>
              <textarea
                id="EditDipositReason"
                required
                #EditDipositReason="ngModel"
                class="form-control"
                rows="2"
                [(ngModel)]="editedDepositOrder.reason"
                [ngModelOptions]="{ standalone: true }"
                placeholder="{{ 'DipositReason' | translate }}"
              >
              </textarea>
            </div>
            <div class="col-lg-6">
              <div style="display: flex; flex-wrap: nowrap; height: 30px">
                <label>{{ "Notes" | translate }}</label>
                <span
                  *ngIf="EditNotes.invalid"
                  class="alert"
                  style="
                    color: red;
                    white-space: nowrap;
                    line-height: 0;
                    padding: 0;
                    margin-top: 8px;
                  "
                >
                  <div *ngIf="EditNotes.errors?.required">*</div>
                </span>
              </div>
              <textarea
                id="EditNotes"
                required
                #EditNotes="ngModel"
                class="form-control"
                rows="2"
                [(ngModel)]="editedDepositOrder.notes"
                [ngModelOptions]="{ standalone: true }"
                placeholder="{{ 'Notes' | translate }}"
              >
              </textarea>
            </div>
          </div>
          <div class="form-group row mt-3">
            <div class="col-lg-4">
              <div class="divformlabel">
                <label>{{ "DipositorName" | translate }}</label>
                <span
                  *ngIf="EditDipositorName.invalid"
                  class="alert"
                  style="
                    color: red;
                    white-space: nowrap;
                    line-height: 0;
                    padding: 0;
                    margin-top: 8px;
                  "
                >
                  <div *ngIf="EditDipositorName.errors?.required">*</div>
                </span>
              </div>
              <input
                id="EditDipositorName"
                required
                #EditDipositorName="ngModel"
                class="form-control"
                [(ngModel)]="editedDepositOrder.dipositorName"
                [ngModelOptions]="{ standalone: true }"
                placeholder="{{ 'DipositorName' | translate }}"
              />
            </div>
            <div class="col-lg-4">
              <div class="divformlabel">
                <label>{{ "DipositorIdentiyType" | translate }}</label>
                <span
                  *ngIf="EditidentityTypes.invalid"
                  class="alert"
                  style="
                    color: red;
                    white-space: nowrap;
                    line-height: 0;
                    padding: 0;
                    margin-top: 8px;
                  "
                >
                  <div *ngIf="EditidentityTypes.errors?.required">*</div>
                </span>
              </div>
              <ng-select
                id="EditidentityTypes"
                required
                #EditidentityTypes="ngModel"
                class="form-control-select"
                [items]="identityTypesArr"
                (change)="changeIdentityType()"
                bindLabel="text"
                bindValue="id"
                [(ngModel)]="editedDepositOrder.dipositorIentiyTypeId"
                [ngModelOptions]="{ standalone: true }"
                placeholder="{{ 'DipositorIdentiyType' | translate }}"
              >
              </ng-select>
            </div>
            <div class="col-lg-4">
              <div class="divformlabel">
                <label>
                  {{ "DipositorIdentiy" | translate }}
                </label>
                <span
                  *ngIf="EditIdentityNumber.invalid"
                  class="alert"
                  style="
                    color: red;
                    white-space: nowrap;
                    line-height: 0;
                    padding: 0;
                    margin-top: 8px;
                  "
                >
                  <div *ngIf="EditIdentityNumber.errors?.required">*</div>
                </span>
              </div>
              <input
                (keyup)="numberOnly($event, true)"
                required
                #EditIdentityNumber="ngModel"
                minlength="10"
                maxlength="10"
                name="IdentityNumber"
                id="IdentityNumber"
                [(ngModel)]="editedDepositOrder.dipositorNId"
                type="text"
                class="form-control"
                placeholder="{{ 'DipositorIdentiy' | translate }}"
              />
              <span
                class="alert"
                style="
                  color: red;
                  white-space: nowrap;
                  line-height: 0;
                  padding: 0;
                  margin-top: 8px;
                  position: absolute;
                "
              >
                <div
                  *ngIf="
                    EditIdentityNumber.errors?.minlength &&
                    isValidIqamaNumber &&
                    isValidIdentityNumber
                  "
                >
                  {{ "IdentityNumberMustBe10Number" | translate }}
                </div>
                <div
                  *ngIf="
                    !isValidIqamaNumber && !EditIdentityNumber.errors?.required
                  "
                >
                  {{ "IqamaNumberMustStartWith2" | translate }}
                </div>
                <div
                  *ngIf="
                    !isValidIdentityNumber && !EditIdentityNumber.errors?.required
                  "
                >
                  {{ "IdentityNumberMustStartWith1" | translate }}
                </div>
              </span>
            </div>
          </div>
          <div class="form-group row mt-3">
            <div class="col-lg-6">
              <div class="divformlabel">
                <label>{{ "EmployeeName" | translate }}</label>
                <span
                  *ngIf="EditEmployeeName.invalid"
                  class="alert"
                  style="
                    color: red;
                    white-space: nowrap;
                    line-height: 0;
                    padding: 0;
                    margin-top: 8px;
                  "
                >
                  <div *ngIf="EditEmployeeName.errors?.required">*</div>
                </span>
              </div>
              <input
                id="EditEmployeeName"
                required
                #EditEmployeeName="ngModel"
                class="form-control"
                [(ngModel)]="editedDepositOrder.employeeName"
                [ngModelOptions]="{ standalone: true }"
                placeholder="{{ 'EmployeeName' | translate }}"
              />
            </div>
            <div class="col-lg-6">
              <div class="divformlabel">
                <label>
                  {{ "EmployeeNId" | translate }}
                </label>
                <span
                  *ngIf="EditEmployeeNId.invalid"
                  class="alert"
                  style="
                    color: red;
                    white-space: nowrap;
                    line-height: 0;
                    padding: 0;
                    margin-top: 8px;
                  "
                >
                  <div *ngIf="EditEmployeeNId.errors?.required">*</div>
                </span>
              </div>
              <input
                (keyup)="numberOnly($event, true)"
                required
                #EditEmployeeNId="ngModel"
                minlength="10"
                maxlength="10"
                name="EmployeeNId"
                id="EmployeeNId"
                [(ngModel)]="editedDepositOrder.employeeNId"
                type="text"
                class="form-control"
                placeholder="{{ 'EmployeeNId' | translate }}"
              />
              <span class="alert" style="color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px;position: absolute;">
                <div *ngIf="!employeeNIdEditIsValid || EditEmployeeNId.errors?.minlength">
                    {{ "IdentityNumberIsNotValid" | translate }}
                </div>
              </span>
            </div>
          </div>
          <div class="form-group row mt-3">
            <div class="col-lg-6">
              <div class="divformlabel">
                <label>{{ "OfficerNameDiposit" | translate }}</label>
                <span
                  *ngIf="EditOfficerNameDiposit.invalid"
                  class="alert"
                  style="
                    color: red;
                    white-space: nowrap;
                    line-height: 0;
                    padding: 0;
                    margin-top: 8px;
                  "
                >
                  <div *ngIf="EditOfficerNameDiposit.errors?.required">*</div>
                </span>
              </div>
              <input
                id="EditOfficerNameDiposit"
                required
                #EditOfficerNameDiposit="ngModel"
                class="form-control"
                [(ngModel)]="editedDepositOrder.officerName"
                [ngModelOptions]="{ standalone: true }"
                placeholder="{{ 'OfficerNameDiposit' | translate }}"
              />
            </div>
            <div class="col-lg-6">
              <div class="divformlabel">
                <label>
                  {{ "OfficerNId" | translate }}
                </label>
                <span
                  *ngIf="EditOfficerNId.invalid"
                  class="alert"
                  style="
                    color: red;
                    white-space: nowrap;
                    line-height: 0;
                    padding: 0;
                    margin-top: 8px;
                  "
                >
                  <div *ngIf="EditOfficerNId.errors?.required">*</div>
                </span>
              </div>
              <input
                (keyup)="numberOnly($event, true)"
                required
                #EditOfficerNId="ngModel"
                minlength="10"
                maxlength="10"
                name="OfficerNId"
                id="OfficerNId"
                [(ngModel)]="editedDepositOrder.officerNId"
                type="text"
                class="form-control"
                placeholder="{{ 'OfficerNId' | translate }}"
              />
              <span class="alert" style="color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px;position: absolute;">
                <div
                  *ngIf="EditOfficerNId.errors?.minlength || !officerNIdEditIsValid">
                  {{ "IdentityNumberIsNotValid" | translate }}
                </div>
              </span>
            </div>
          </div>
          <div class="form-group row mt-3">
            <div class="col-lg-6 row">
              <div style="display: flex; flex-wrap: nowrap; height: 30px">
                <label>{{ "IsVisitAllowed" | translate }}</label>
              </div>
              <div class="col-lg-6">
                <div
                  class="custom-control custom-checkbox"
                  style="display: flex; align-items: center"
                >
                  <input
                    [checked]="editedDepositOrder.isVisitAllowed == true"
                    (change)="editedDepositOrder.isVisitAllowed = true"
                    type="radio"
                    name="isVisitedAllowed"
                  />
                  <label style="margin-top: 4px">
                    <span>{{ "Yes" | translate }}</span>
                  </label>
                </div>
              </div>
              <div class="col-lg-6">
                <div
                  class="custom-control custom-checkbox"
                  style="display: flex; align-items: center"
                >
                  <input
                    [checked]="editedDepositOrder.isVisitAllowed == false"
                    (change)="editedDepositOrder.isVisitAllowed = false"
                    type="radio"
                    name="isVisitedAllowed"
                  />
                  <label style="margin-top: 4px">
                    <span>{{ "No" | translate }}</span>
                  </label>
                </div>
              </div>
            </div> 
            <div class="col-lg-6 row">
              <div style="display: flex; flex-wrap: nowrap; height: 30px">
                <label>{{ "DepositType" | translate }}</label>
              </div>
              <div class="col-lg-6">
                <div
                  class="custom-control custom-checkbox"
                  style="display: flex; align-items: center"
                >
                  <input
                    [checked]="editedDepositOrder.isNormal == true"
                    (change)="editedDepositOrder.isNormal = true"
                    type="radio"
                    name="isNormal"
                  />
                  <label style="margin-top: 4px">
                    <span>{{ "Normal" | translate }}</span>
                  </label>
                </div>
              </div>
              <div class="col-lg-6">
                <div
                  class="custom-control custom-checkbox"
                  style="display: flex; align-items: center"
                >
                  <input
                    [checked]="editedDepositOrder.isNormal == false"
                    (change)="editedDepositOrder.isNormal = false"
                    type="radio"
                    name="isNormal"
                  />
                  <label style="margin-top: 4px">
                    <span>{{ "UnNormal" | translate }}</span>
                  </label>
                </div>
              </div>
            </div> 
          </div>
          <div class="row mt-3" style="justify-content: center;">
            <button [disabled]="!officerNIdEditIsValid || !employeeNIdEditIsValid ||EditDepositOrderNumber.invalid || EditDepositPeriod.invalid || !editedDepositOrder.depositDate || EditDepositBranch.invalid || EditDipositReason.invalid || EditNotes.invalid || EditDipositorName.invalid || EditidentityTypes.invalid || !isValidIdentityNumber || !isValidIqamaNumber || EditIdentityNumber.invalid || EditEmployeeName.invalid || EditEmployeeNId.invalid || EditOfficerNameDiposit.invalid || EditOfficerNId.invalid " 
              (click)="onEditDepositOrder()"
              style="color: black; font-weight: bold"
              type="button"
              class="btn btn-primary col-lg-3 m-1"
            >
              {{ "Save and Back" | translate }}
            </button>
            <button
              type="button"
              class="btn btn-danger col-lg-3 m-1"
              (click)="showAddPage=false; showEditPage=false;"
            >
              {{ "BackLists" | translate }}
            </button>
          </div>
          
        </div>
      </div>
    </div>
</div>


<ng-template #deleteModal let-modal>
  <div class="modal-header" style="justify-content: center">
      <h4 class="modal-title" id="modal-basic-title">
          {{ "ConfirmDeleteOperation" | translate }}
      </h4>
  </div>
  <div class="modal-body text-center">
      <p>{{ "SelectedRecordwillbeDeleted" | translate }}</p>
  </div>
  <div class="modal-footer">
      <button type="button" class="btn btn-danger" (click)="onDeleteDepositOrder(modal)">
          {{ "YES" | translate }}
      </button>
      <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
          {{ "NO" | translate }}
      </button>
  </div>
</ng-template>
<ng-template #depositOrderPreviewModal let-modal>
  <div class="modal-header" style="justify-content: space-between">
    <h4 class="modal-title" id="modal-basic-title">
      {{ "PreviewDepositeOrder" | translate }}
    </h4>

    <i
      style="font-size: 20px"
      class="fa fa-close"
      (click)="modal.dismiss('Cross click')"
    ></i>
  </div>
  <div class="modal-body">
      <div class="custom-form">
          <div class="col-12 offset-1">
            <div class="card p-3">
              <div class="form-group row">
                <div class="col-lg-6">
                  <label>{{ "DepositOrderNumber" | translate }}</label>
                  <span class="form-control" readonly>{{editedDepositOrder.depositOrderNumber}}&nbsp;</span>
                  
                </div>
                <div class="col-lg-6">
                  <label> {{ "DepositPeriod" | translate }} </label>
                  <span class="form-control" readonly>{{editedDepositOrder.period }}&nbsp;</span>
                </div>
              </div>
              <div class="form-group row mt-3">
                <div class="col-lg-6">
                  <label> {{ "DepositDate" | translate }}</label>
                  <span class="form-control" readonly>{{editedDepositOrder.depositDate | toDateOnly }}&nbsp;</span>
                </div> 
                <div class="col-lg-6">
                  <label>{{ "DepositBranch" | translate }}</label>
                  <span class="form-control" readonly>{{editedDepositOrder.depositAreaName}}&nbsp;</span>
                </div>
              </div>
              <div class="form-group row mt-3">
                <div class="col-lg-6">
                  <label>{{ "DipositReason" | translate }}</label>
                  <span class="form-control" readonly>{{editedDepositOrder.reason }}&nbsp;</span>
                </div>
                <div class="col-lg-6">
                  <label>{{ "Notes" | translate }}</label>
                  <span class="form-control" readonly>{{editedDepositOrder.notes}}&nbsp;</span>
                </div>
              </div>
              <div class="form-group row mt-3">
                <div class="col-lg-6">
                  <label>{{ "DipositorName" | translate }}</label>
                  <span class="form-control" readonly>{{editedDepositOrder.dipositorName}}&nbsp;</span>
                </div>
                <div class="col-lg-6">
                  <label>
                    {{ "DipositorIdentiy" | translate }}
                  </label>
                  <span class="form-control" readonly>{{editedDepositOrder.dipositorNId}}&nbsp;</span>
                </div>
              </div>
              <div class="form-group row mt-3">
                <div class="col-lg-6">
                  <label>{{ "EmployeeName" | translate }}</label>
                  <span class="form-control" readonly>{{editedDepositOrder.employeeName}}&nbsp;</span>
                </div>
                <div class="col-lg-6">
                  <label> {{ "EmployeeNId" | translate }}</label>
                  <span class="form-control" readonly>{{editedDepositOrder.employeeNId}}&nbsp;</span>
                </div>
              </div>
              <div class="form-group row mt-3">
                <div class="col-lg-6">
                  <label>{{ "OfficerNameDiposit" | translate }}</label>
                  <span class="form-control" readonly>{{editedDepositOrder.officerName}}&nbsp;</span>
                </div>
                <div class="col-lg-6">
                  <label>{{ "OfficerNId" | translate }} </label>
                  <span class="form-control" readonly>{{editedDepositOrder.officerNId}}&nbsp;</span>
                </div>
              </div>
              <div class="form-group row mt-3">
                <div class="col-lg-6">
                  <label>{{ "IsVisitAllowed" | translate }}</label>
                  <span *ngIf="editedDepositOrder.isVisitAllowed" class="form-control" readonly>{{"Yes" | translate}} &nbsp;</span>
                  <span *ngIf="!editedDepositOrder.isVisitAllowed" class="form-control" readonly>{{"No" | translate}} &nbsp;</span>
                </div> 
                <div class="col-lg-6">
                  <label>{{ "DepositType" | translate }}</label>
                  <span *ngIf="editedDepositOrder.isNormal" class="form-control" readonly>{{"Normal" | translate}} &nbsp;</span>
                  <span *ngIf="!editedDepositOrder.isNormal" class="form-control" readonly>{{"UnNormal" | translate}} &nbsp;</span>
                </div> 
              </div>
            </div>
          </div>
      </div>
  </div>
  <div class="modal-footer row" style="justify-content: flex-end; padding: 1rem 2rem" >
      <button type="button" class="btn btn-danger col-lg-2" (click)="modal.dismiss('Cross click')">
          {{ "Close" | translate }}
      </button>
  </div>
  
</ng-template>